module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-W4MR5MG","includeInDevelopment":true,"defaultDataLayer":null,"routeChangeEventName":"gatsby-route-change"},
    },{
      plugin: require('../node_modules/@prismicio/gatsby-source-prismic-graphql/gatsby-browser.js'),
      options: {"plugins":[],"repositoryName":"promo-betcenter-be","shortenUrlLangs":true,"defaultLang":"en-gb","langs":["de-de","nl-be","fr-be",null,"tr","en-gb","de-de"],"previews":false,"pages":[{"type":"Page","match":"/:lang/:uid","component":"/opt/build/repo/src/app/page.js"},{"type":"Page","match":":uid","component":"/opt/build/repo/src/app/page-hook.js"},{"type":"Page","match":"","component":"/opt/build/repo/src/app/page-hook.js"}],"sharpKeys":[{},"profilepic"]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
